import _ from 'lodash';
import jQuery from 'jquery';

// TODO: remove condition when code spliting enabled (see index.js)
if (!process.env.production) {
    Mobi2Go.Dev = {};

    let timeout;
    // This script provides a function to reload the style sheets from the server without reloading the page
    _.extend(Mobi2Go.Dev, {
        refreshStyleSheets(qs, callback) {
            let url = `${Mobi2Go.app.base_url}/store/embed/${
                Mobi2Go.headoffice.id
            }/stylesheets.json?css_only&ui=${
                Mobi2Go.app.ui_name
            }&${window.location.search.substring(1)}`;

            if (typeof qs === 'string' && qs !== '') {
                url += `&${qs}`;
            }

            showPreviewLoadingMessage();
            jQuery.getJSON(url, function(response) {
                const new_sheets = response.stylesheets;
                const { errors } = response;

                if (errors.length) console.log(errors);

                // If new sheets aren't exactly the same as existing loaded sheets, replace them!
                if (!_.isEqual(new_sheets, Mobi2Go.app.style_sheets)) {
                    jQuery('link.m2g').addClass('old');
                    Mobi2Go.helpers.loadStyleSheets(new_sheets);
                    Mobi2Go.app.style_sheets = new_sheets;

                    setTimeout(hidePreviewLoadingMessage, 100);
                    clearTimeout(timeout);
                    jQuery('link.m2g.old').remove();

                    _.isFunction(callback) && callback();
                    return;
                }
                hidePreviewLoadingMessage();
                _.isFunction(callback) && callback();
            });
        },
        // Keep refreshing stylesheets at a set interval
        cssAutoRefresh(interval) {
            jQuery('#loading-overlay').remove();

            if (Mobi2Go.app.isMobileUI()) {
                setInterval(Mobi2Go.Dev.refreshStyleSheets, 1200);
            } else {
                jQuery('body').mousemove(
                    _.throttle(Mobi2Go.Dev.refreshStyleSheets, 10000)
                );
            }
        },
    });

    // Listen for iframe postMessage for requests from console theme editor
    // page to refresh the style sheets for style previews
    if (window.addEventListener)
        // normal browsers
        window.addEventListener('message', previewRequest, false);
    else if (window.attachEvent)
        // IE
        window.attachEvent('onmessage', previewRequest);

    let removed_headoffice_theme = false;
    function previewRequest(message) {
        let response;
        try {
            response = JSON.parse(message.data);
        } catch (e) {
            return;
        }
        if (!response.preview) return;

        // Change theme
        if (response.theme_name) {
            Mobi2Go.Dev.refreshStyleSheets(
                `no_minify&headoffice_theme=preview&theme=${response.theme_name}`
            );
        }

        // Change layout
        if (response.layout_name) {
            jQuery('#m2g-view').attr(
                'class',
                `m2g-view ${response.layout_name}`
            );
        }

        if (response.style_sheet) {
            if (!removed_headoffice_theme) {
                // Remove headoffice theme style sheet
                jQuery('link.m2g[href*="store-cache-theme"]').remove();
                removed_headoffice_theme = true;
            }
            jQuery('#custom-stylesheet').remove();
            jQuery(
                `<style id="custom-stylesheet" class="m2g">${response.style_sheet}</style>`
            ).appendTo('head');
        }
    }

    const $preview_loader = jQuery('#loading-overlay');

    function showPreviewLoadingMessage() {
        $preview_loader.show();
    }

    function hidePreviewLoadingMessage() {
        $preview_loader.fadeOut(200);
    }

    if ('live_css' in Mobi2Go.helpers.getQueryStringAsObject()) {
        Mobi2Go.Dev.cssAutoRefresh();
    }
}
